export default "__VITE_ASSET__BcLcRs9U__"